import { diag_code_ids } from "../../../Shared/diagcode"
import { devicesTypeValues } from '../../../Shared/utils';

const line_separator = " / ";

const fixAndParse = (inText) => {
  let fixed = inText;

  fixed = fixed.replace(/[^\x20-\x7F]/g, x => "\\u" + ("000" + x.codePointAt(0).toString(16)).slice(-4));

  fixed = fixed.replace(/\\/g, '\\\\');
  fixed = fixed.replace(/\n/g, ' ');
  fixed = fixed.replace(/\r/g, ' ');
  fixed = fixed.replace(/\t/g, '   ');
  fixed = fixed.replace(/&lt;/g, '<');
  fixed = fixed.replace(/&gt;/g, '>');
  fixed = fixed.replace(/&amp;/g, '&');

  try {
    let jsonFixed = JSON.parse(fixed);

    for (const key of Object.keys(jsonFixed)) {
      jsonFixed[key] = jsonFixed[key].replace(/&quot;/g, '\"');
      jsonFixed[key] = jsonFixed[key].replace(/&apos;/g, '\'');

      var r = /\\u([\d\w]{4})/gi;
      jsonFixed[key] = jsonFixed[key].replace(r, function (match, grp) {
        return String.fromCharCode(parseInt(grp, 16));
      });
    }
    return jsonFixed;
  }
  catch (e) {
    console.log("31 - Error=", e, inText, fixed);
  }
  return {};
}




export const getWidgetDataForImageDeployment = (values) => {

  const retRows = [];
  /*
    All devices	        <nb passed>	<nb failed>	<nb other>	<raw sum>
    All unique devices	<nb passed>	<nb failed>	<nb other>	<raw sum>
  */

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {

    // ALL DEVICES --------------------------------------
    const newAllDevicesRow = {
      id: 0,
      firstColumn: values.t('reporting.columns.statistics.all_devices'),//"All devices",
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    for (const row of values.rows) {
      const dep = values.deployments[row.key];

      switch (dep.module_1115_result) {
        case "OK":
          newAllDevicesRow.passed = newAllDevicesRow.passed + 1;
          break;

        case "KO":
        case "FAIL":
        case "FAILED":
        case "FAILURE":
          newAllDevicesRow.failed = newAllDevicesRow.failed + 1;
          break;

        case null:
          // console.log("75 - module_1115_result....");
          newAllDevicesRow.other = newAllDevicesRow.other + 1;
          break;

        default:
          newAllDevicesRow.other = newAllDevicesRow.other + 1;
      }
    }
    newAllDevicesRow.total = newAllDevicesRow.passed + newAllDevicesRow.failed + newAllDevicesRow.other;
    retRows.push(newAllDevicesRow);
    // ALL DEVICES --------------------------------------


    // ALL UNIQUE DEVICES -------------------------------
    const newAllUniqueDevicesRow = {
      id: 1,
      firstColumn: values.t('reporting.columns.statistics.all_unique_devices'),
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    const filteredDeployments = [];
    for (const row of values.rows) {
      const dep = values.deployments[row.key];
      filteredDeployments.push(dep);
    }

    const orderedDeployments = filteredDeployments.sort((a, b) => {
      return a.module_1115_start_date < b.module_1115_start_date ? 1 : -1;
    });

    const uniqueDeployments = new Map();

    for (const dep of orderedDeployments) {
      switch (dep.module_1115_result) {
        case "OK":
          let passedTab = uniqueDeployments.get("passed") || [];
          passedTab.push(dep);
          uniqueDeployments.set("passed", passedTab);
          break;

        case "KO":
        case "FAIL":
        case "FAILED":
        case "FAILURE":
          let failedTab = uniqueDeployments.get("failed") || [];
          failedTab.push(dep);
          uniqueDeployments.set("failed", failedTab);
          break;

        case null: {
          let otherTab = uniqueDeployments.get("other") || [];
          otherTab.push(dep);
          uniqueDeployments.set("other", otherTab);
          break;
        }

        default: {
          let otherTab = uniqueDeployments.get("other") || [];
          otherTab.push(dep);
          uniqueDeployments.set("other", otherTab);
      }
    }
    }
    // console.log("137 - uniqueDeployments=", uniqueDeployments);

    for (const key of Array.from(uniqueDeployments.keys())) {
      const arrayTmp = [];
      for (const dep of uniqueDeployments.get(key)) {

        // const found = arrayTmp.find(d => d.system_serial === dep.system_serial);
        const found = arrayTmp.find(d => {
          // if (d.system_serial === dep.system_serial) {
          if (
            d && dep &&
            (
              (values.scenario && values.scenario.devicesType === devicesTypeValues.PCs && d.system_serial === dep.system_serial)
              ||
              (values.scenario && values.scenario.devicesType === devicesTypeValues.disks && d.serial === dep.serial)
            )
          ) {

            const cpuListDep = dep.cpu_data && dep.cpu_data.split('<cpu>');
            let cpuModelDep = "";
            if (cpuListDep) {
              cpuListDep.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelDep !== "")
                    cpuModelDep = cpuModelDep + line_separator;
                  cpuModelDep += cpuData.model;
                }
              });
            }

            const cpuListD = d.cpu_data && d.cpu_data.split('<cpu>');
            let cpuModelD = "";
            if (cpuListD) {
              cpuListD.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelD !== "")
                    cpuModelD = cpuModelD + line_separator;
                  cpuModelD += cpuData.model;
                }
              });
            }

            if (
              d.system_uuid === dep.system_uuid &&
              d.motherboard_model === dep.motherboard_model &&
              cpuModelD === cpuModelDep
            ) {
              return true;
            }
          }
          return false;
        });
      if (!found) {
          arrayTmp.push(dep);
        }
      }
      // console.log("150 - arrayTmp=", arrayTmp);
      newAllUniqueDevicesRow[key] = arrayTmp.length;
    }
    newAllUniqueDevicesRow.total = newAllUniqueDevicesRow.passed + newAllUniqueDevicesRow.failed + newAllUniqueDevicesRow.other;
    retRows.push(newAllUniqueDevicesRow);
    // ALL UNIQUE DEVICES -------------------------------

  }
  return retRows;
      }



export const getWidgetDataForImageCapture = (values) => {

  const retRows = [];
  /*
    All devices	        <nb passed>	<nb failed>	<nb other>	<raw sum>
    All unique devices	<nb passed>	<nb failed>	<nb other>	<raw sum>
  */

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {

    // ALL DEVICES --------------------------------------
    const newAllDevicesRow = {
      id: 0,
      firstColumn: values.t('reporting.columns.statistics.all_devices'),//"All devices",
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    for (const row of values.rows) {
      const dep = values.deployments[row.key];

      switch (dep.module_1123_module_result) {
        case "OK":
          newAllDevicesRow.passed = newAllDevicesRow.passed + 1;
          break;

        case "KO":
        case "FAIL":
        case "FAILED":
        case "FAILURE":
          newAllDevicesRow.failed = newAllDevicesRow.failed + 1;
          break;

        case null:
          // console.log("195 - module_1123_module_result....");
          newAllDevicesRow.other = newAllDevicesRow.other + 1;
          break;

        default:
          newAllDevicesRow.other = newAllDevicesRow.other + 1;
      }
    }
    newAllDevicesRow.total = newAllDevicesRow.passed + newAllDevicesRow.failed + newAllDevicesRow.other;
    retRows.push(newAllDevicesRow);
    // ALL DEVICES --------------------------------------


    // ALL UNIQUE DEVICES -------------------------------
    const newAllUniqueDevicesRow = {
      id: 1,
      firstColumn: values.t('reporting.columns.statistics.all_unique_devices'),
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
      }

    const filteredDeployments = [];
    for (const row of values.rows) {
      const dep = values.deployments[row.key];
      filteredDeployments.push(dep);
    }

    const orderedDeployments = filteredDeployments.sort((a, b) => {
      return a.date < b.date ? 1 : -1;
    });

    const uniqueDeployments = new Map();

    for (const dep of orderedDeployments) {
      switch (dep.module_1123_module_result) {
        case "OK":
          let passedTab = uniqueDeployments.get("passed") || [];
          passedTab.push(dep);
          uniqueDeployments.set("passed", passedTab);
          break;

        case "KO":
        case "FAIL":
        case "FAILED":
        case "FAILURE":
          let failedTab = uniqueDeployments.get("failed") || [];
          failedTab.push(dep);
          uniqueDeployments.set("failed", failedTab);
          break;

        case null: {
          let otherTab = uniqueDeployments.get("other") || [];
          otherTab.push(dep);
          uniqueDeployments.set("other", otherTab);
          break;
        }

        default: {
          let otherTab = uniqueDeployments.get("other") || [];
          otherTab.push(dep);
          uniqueDeployments.set("other", otherTab);
      }
    }
    }


    for (const key of Array.from(uniqueDeployments.keys())) {
      const arrayTmp = [];
      for (const dep of uniqueDeployments.get(key)) {

        // const found = arrayTmp.find(d => d.system_serial === dep.system_serial);
        const found = arrayTmp.find(d => {
          // if (d.system_serial === dep.system_serial) {

          if (
            d && dep &&
            (
              (values.scenario && values.scenario.devicesType === devicesTypeValues.PCs && d.system_serial === dep.system_serial)
              ||
              (values.scenario && values.scenario.devicesType === devicesTypeValues.disks && d.serial === dep.serial)
            )
          ) {

            const cpuListDep = dep.cpu_data && dep.cpu_data.split('<cpu>');
            let cpuModelDep = "";
            if (cpuListDep) {
              cpuListDep.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelDep !== "")
                    cpuModelDep = cpuModelDep + line_separator;
                  cpuModelDep += cpuData.model;
                }
              });
            }

            const cpuListD = d.cpu_data && d.cpu_data.split('<cpu>');
            let cpuModelD = "";
            if (cpuListD) {
              cpuListD.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelD !== "")
                    cpuModelD = cpuModelD + line_separator;
                  cpuModelD += cpuData.model;
                }
              });
            }

            if (
              d.system_uuid === dep.system_uuid &&
              d.motherboard_model === dep.motherboard_model &&
              cpuModelD === cpuModelDep
            ) {
              return true;
            }
          }
          return false;
        });
        if (!found) {
          arrayTmp.push(dep);
        }
      }
      newAllUniqueDevicesRow[key] = arrayTmp.length;
    }
    newAllUniqueDevicesRow.total = newAllUniqueDevicesRow.passed + newAllUniqueDevicesRow.failed + newAllUniqueDevicesRow.other;
    retRows.push(newAllUniqueDevicesRow);
    // ALL UNIQUE DEVICES -------------------------------

  }
  return retRows;
}



export const getWidgetDataForImageCapturePerOS = (values) => {

  const retRows = [];

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {
    const cumul = {
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    const mapOSVersionData = new Map();

    for (const row of values.rows) {
      const dep = values.deployments[row.key];

      let result = dep && dep.module_1123_module_result;
      const OSVersion = dep && dep.added_osversion || "";

      if (OSVersion !== "") {
        let data = mapOSVersionData.get(OSVersion);

        if (!data) {
          data = {
            passed: 0,
            failed: 0,
            other: 0,
            total: 0
          }
        }

        switch (result) {
          case "OK":
            data.passed = data.passed + 1;
            cumul.passed = cumul.passed + 1;
            cumul.total = cumul.total + 1;
            break;

          case "KO":
          case "FAIL":
          case "FAILED":
          case "FAILURE":
            data.failed = data.failed + 1;
            cumul.failed = cumul.failed + 1;
            cumul.total = cumul.total + 1;
            break;

          case null:
            // console.log("327 - module_1123_module_result....");
            data.other = data.other + 1;
            cumul.other = cumul.other + 1;
            cumul.total = cumul.total + 1;
            break;

          default:
            data.other = data.other + 1;
            cumul.other = cumul.other + 1;
            cumul.total = cumul.total + 1;
        }
        data.total = data.passed + data.failed + data.other;
        mapOSVersionData.set(OSVersion, data);

      }
    }

    const sortedMap = [...mapOSVersionData].sort((a, b) => {
      return a[0].toUpperCase().localeCompare(b[0].toUpperCase())
    })

    const finalMapOSVersionData = new Map(sortedMap);

    let indiceId = 0;
    finalMapOSVersionData.forEach((value, key, map) => {

      const newRow = {
        id: indiceId,
        firstColumn: key,
        passed: value.passed,
        failed: value.failed,
        other: value.other,
        total: value.total
      }
      retRows.push(newRow);
      indiceId = indiceId + 1;
    });

    const newRow = {
      id: indiceId,
      firstColumn: 'TOTAL',
      passed: cumul.passed,
      failed: cumul.failed,
      other: cumul.other,
      total: cumul.total,
      cumulRow: true
    }
    retRows.push(newRow);
  }
  return retRows;
}



export const getWidgetDataForDeviceErasure = (values) => {

  const retRows = [];
  /*
      All devices wiped	                            <nb passed>	<nb failed>	<nb other>	<raw sum>
      Unique devices with up to 2 disks wiped	      <nb passed>	<nb failed>	<nb other>	<raw sum>
      Unique devices with at least 3 disks wiped	  <nb passed>	<nb failed>	<nb other>	<raw sum>
      All unique devices wiped	                    <nb passed>	<nb failed>	<nb other>	<raw sum>
  */
  // console.log("482 - values=", values);

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {

    // ALL DEVICES --------------------------------------
    const newAllDevicesRow = {
      id: 0,
      firstColumn: values.t('reporting.columns.statistics.all_devices_wiped'),//"All devices",
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    for (const row of values.rows) {
      const dep = values.deployments[row.key];

      switch (dep.module_1126_result) {
        case "OK":
          newAllDevicesRow.passed = newAllDevicesRow.passed + 1;
          break;

        case "KO":
        case "FAIL":
        case "FAILED":
        case "FAILURE":
          newAllDevicesRow.failed = newAllDevicesRow.failed + 1;
          break;

        case null:
          // console.log("416 - module_1126_result....");
          newAllDevicesRow.other = newAllDevicesRow.other + 1;
          break;

        default:
          newAllDevicesRow.other = newAllDevicesRow.other + 1;
      }
    }
    newAllDevicesRow.total = newAllDevicesRow.passed + newAllDevicesRow.failed + newAllDevicesRow.other;
    retRows.push(newAllDevicesRow);
    // ALL DEVICES --------------------------------------



    // ALL UNIQUE DEVICES (with up to 2 & more than 3 disks) ----------
    const newAllUniqueDevicesRow2 = {
      id: 1,
      firstColumn: values.t('reporting.columns.statistics.unique_devices_2_disks'),
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    const newAllUniqueDevicesRow3 = {
      id: 2,
      firstColumn: values.t('reporting.columns.statistics.unique_devices_3_disks'),
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    const newAllUniqueDevicesRowAll = {
      id: 3,
      firstColumn: values.t('reporting.columns.statistics.all_unique_devices_all_disks'),
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    const filteredDeployments2 = [];
    const filteredDeployments3 = [];
    const filteredDeploymentsAll = [];

    for (const row of values.rows) {
      const dep = values.deployments[row.key];

      const diskList = dep.disk_data && dep.disk_data.split('<disk>');
      // console.log('174 - diskList=', diskList);

      if (diskList) {
        if (diskList.length <= 2)
          filteredDeployments2.push(dep);
        else if (diskList.length >= 3)
          filteredDeployments3.push(dep);

        filteredDeploymentsAll.push(dep);
      }
    }


    const orderedDeployments2 = filteredDeployments2.sort((a, b) => {
      return a.module_1126_start_date < b.module_1126_start_date ? 1 : -1;
    });

    const uniqueDeployments2 = new Map();
    for (const dep of orderedDeployments2) {
      switch (dep.module_1126_result) {
        case "OK":
          let passedTab = uniqueDeployments2.get("passed") || [];
          passedTab.push(dep);
          uniqueDeployments2.set("passed", passedTab);
          break;

        case "KO":
        case "FAIL":
        case "FAILED":
        case "FAILURE":
          let failedTab = uniqueDeployments2.get("failed") || [];
          failedTab.push(dep);
          uniqueDeployments2.set("failed", failedTab);
          break;

        case null: {
          let otherTab = uniqueDeployments2.get("other") || [];
          otherTab.push(dep);
          uniqueDeployments2.set("other", otherTab);
          break;
        }

        default: {
          let otherTab = uniqueDeployments2.get("other") || [];
          otherTab.push(dep);
          uniqueDeployments2.set("other", otherTab);
      }
    }
    }
    for (const key of Array.from(uniqueDeployments2.keys())) {
      const arrayTmp = [];
      for (const dep of uniqueDeployments2.get(key)) {

        // const found = arrayTmp.find(d => d.system_serial === dep.system_serial);
        const found = arrayTmp.find(d => {
          // if (d.system_serial === dep.system_serial) {
          if (
            d && dep &&
            (
              (values.scenario && values.scenario.devicesType === devicesTypeValues.PCs && d.system_serial === dep.system_serial)
              ||
              (values.scenario && values.scenario.devicesType === devicesTypeValues.disks && d.serial === dep.serial)
            )
          ) {

            const cpuListDep = dep.cpu_data && dep.cpu_data.split('<cpu>');
            let cpuModelDep = "";
            if (cpuListDep) {
              cpuListDep.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelDep !== "")
                    cpuModelDep = cpuModelDep + line_separator;
                  cpuModelDep += cpuData.model;
                }
              });
            }

            const cpuListD = d.cpu_data && d.cpu_data.split('<cpu>');
            let cpuModelD = "";
            if (cpuListD) {
              cpuListD.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelD !== "")
                    cpuModelD = cpuModelD + line_separator;
                  cpuModelD += cpuData.model;
                }
              });
            }

            if (
              d.system_uuid === dep.system_uuid &&
              d.motherboard_model === dep.motherboard_model &&
              cpuModelD === cpuModelDep
            ) {
              return true;
            }
          }
          return false;
        });
        if (!found) {
          arrayTmp.push(dep);
        }
      }
      newAllUniqueDevicesRow2[key] = arrayTmp.length;
    }
    newAllUniqueDevicesRow2.total = newAllUniqueDevicesRow2.passed + newAllUniqueDevicesRow2.failed + newAllUniqueDevicesRow2.other;
    retRows.push(newAllUniqueDevicesRow2);


    const orderedDeployments3 = filteredDeployments3.sort((a, b) => {
      return a.module_1126_start_date < b.module_1126_start_date ? 1 : -1;
    });

    const uniqueDeployments3 = new Map();
    for (const dep of orderedDeployments3) {
      switch (dep.module_1126_result) {
        case "OK":
          let passedTab = uniqueDeployments3.get("passed") || [];
          passedTab.push(dep);
          uniqueDeployments3.set("passed", passedTab);
          break;

        case "KO":
        case "FAIL":
        case "FAILED":
        case "FAILURE":
          let failedTab = uniqueDeployments3.get("failed") || [];
          failedTab.push(dep);
          uniqueDeployments3.set("failed", failedTab);
          break;

        case null: {
          let otherTab = uniqueDeployments3.get("other") || [];
          otherTab.push(dep);
          uniqueDeployments3.set("other", otherTab);        
          break;
        }

        default: {
          let otherTab = uniqueDeployments3.get("other") || [];
          otherTab.push(dep);
          uniqueDeployments3.set("other", otherTab);
      }
    }
    }
    for (const key of Array.from(uniqueDeployments3.keys())) {
      const arrayTmp = [];
      for (const dep of uniqueDeployments3.get(key)) {

        // const found = arrayTmp.find(d => d.system_serial === dep.system_serial);
        const found = arrayTmp.find(d => {
          //if (d.system_serial === dep.system_serial) {
          if (
            d && dep &&
            (
              (values.scenario && values.scenario.devicesType === devicesTypeValues.PCs && d.system_serial === dep.system_serial)
              ||
              (values.scenario && values.scenario.devicesType === devicesTypeValues.disks && d.serial === dep.serial)
            )
          ) {

            const cpuListDep = dep.cpu_data && dep.cpu_data.split('<cpu>');
            let cpuModelDep = "";
            if (cpuListDep) {
              cpuListDep.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelDep !== "")
                    cpuModelDep = cpuModelDep + line_separator;
                  cpuModelDep += cpuData.model;
                }
              });
            }

            const cpuListD = d.cpu_data && d.cpu_data.split('<cpu>');
            let cpuModelD = "";
            if (cpuListD) {
              cpuListD.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelD !== "")
                    cpuModelD = cpuModelD + line_separator;
                  cpuModelD += cpuData.model;
                }
              });
            }

            if (
              d.system_uuid === dep.system_uuid &&
              d.motherboard_model === dep.motherboard_model &&
              cpuModelD === cpuModelDep
            ) {
              return true;
            }
          }
          return false;
        });
        if (!found) {
          arrayTmp.push(dep);
      }
      }
      newAllUniqueDevicesRow3[key] = arrayTmp.length;
    }
    newAllUniqueDevicesRow3.total = newAllUniqueDevicesRow3.passed + newAllUniqueDevicesRow3.failed + newAllUniqueDevicesRow3.other;
    retRows.push(newAllUniqueDevicesRow3);


    const orderedDeploymentsAll = filteredDeploymentsAll.sort((a, b) => {
      return a.module_1126_start_date < b.module_1126_start_date ? 1 : -1;
    });


    const uniqueDeploymentsAll = new Map();
    for (const dep of orderedDeploymentsAll) {
      switch (dep.module_1126_result) {
        case "OK":
          let passedTab = uniqueDeploymentsAll.get("passed") || [];
          passedTab.push(dep);
          uniqueDeploymentsAll.set("passed", passedTab);
          break;

        case "KO":
        case "FAIL":
        case "FAILED":
        case "FAILURE":
          let failedTab = uniqueDeploymentsAll.get("failed") || [];
          failedTab.push(dep);
          uniqueDeploymentsAll.set("failed", failedTab);
          break;

        case null: {
          let otherTab = uniqueDeploymentsAll.get("other") || [];
          otherTab.push(dep);
          uniqueDeploymentsAll.set("other", otherTab);
          break;
        }

        default: {
          let otherTab = uniqueDeploymentsAll.get("other") || [];
          otherTab.push(dep);
          uniqueDeploymentsAll.set("other", otherTab);
      }
    }
    }
    // for (const key of Array.from(uniqueDeploymentsAll.keys())) {
    //   const arrayTmp = [];
    //   for (const dep of uniqueDeploymentsAll.get(key)) {

    //     const found = arrayTmp.find(d => d.system_serial === dep.system_serial);
    //     if (!found) {
    //       arrayTmp.push(dep);
    //     }
    //   }
    //   newAllUniqueDevicesRowAll[key] = arrayTmp.length;
    // }
    for (const key of Array.from(uniqueDeploymentsAll.keys())) {
      const arrayTmp = [];
      for (const dep of uniqueDeploymentsAll.get(key)) {

        // const found = arrayTmp.find(d => d.system_serial === dep.system_serial);
        const found = arrayTmp.find(d => {
          //if (d.system_serial === dep.system_serial) {
          if (
            d && dep &&
            (
              (values.scenario && values.scenario.devicesType === devicesTypeValues.PCs && d.system_serial === dep.system_serial)
              ||
              (values.scenario && values.scenario.devicesType === devicesTypeValues.disks && d.serial === dep.serial)
            )
          ) {

            const cpuListDep = dep.cpu_data && dep.cpu_data.split('<cpu>');
            let cpuModelDep = "";
            if (cpuListDep) {
              cpuListDep.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelDep !== "")
                    cpuModelDep = cpuModelDep + line_separator;
                  cpuModelDep += cpuData.model;
                }
              });
            }

            const cpuListD = d.cpu_data && d.cpu_data.split('<cpu>');
            let cpuModelD = "";
            if (cpuListD) {
              cpuListD.forEach(cpu => {
                const cpuData = fixAndParse(cpu);
                if (cpuData.model !== "") {
                  if (cpuModelD !== "")
                    cpuModelD = cpuModelD + line_separator;
                  cpuModelD += cpuData.model;
                }
              });
            }

            if (
              d.system_uuid === dep.system_uuid &&
              d.motherboard_model === dep.motherboard_model &&
              cpuModelD === cpuModelDep
            ) {
              return true;
            }
          }
          return false;
        });
        if (!found) {
          arrayTmp.push(dep);
        }
      }
      newAllUniqueDevicesRowAll[key] = arrayTmp.length;
    }

    newAllUniqueDevicesRowAll.total = newAllUniqueDevicesRowAll.passed + newAllUniqueDevicesRowAll.failed + newAllUniqueDevicesRowAll.other;
    retRows.push(newAllUniqueDevicesRowAll);
    // ALL UNIQUE DEVICES -------------------------------

  }
  return retRows;
}



export const getWidgetDataForDiskErasurePerCapacity = (values) => {
  const retRows = [];
  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {
    const cumul = {
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    const mapDiskData = new Map();

    for (const row of values.rows) {
      const arrayDisk = [];
      const dep = values.deployments[row.key];
      const wipedList = dep.wiped_data && dep.wiped_data.split('<wiped>');

      if (wipedList) {
        wipedList.forEach(wipe => {
          const diskData = fixAndParse(wipe);
          arrayDisk.push(diskData);
        });

        arrayDisk.map((disk, index) => {

          // console.log("391 - disk=", disk);
          let result = disk && disk.result;
          const size_commercial = disk && disk.size_commercial || "";

          if (size_commercial) {
            let data = mapDiskData.get(size_commercial);

            if (!data) {
              data = {
                passed: 0,
                failed: 0,
                other: 0,
                total: 0
              }
            }

            if (result && result.toUpperCase().substring(0, 26) === "SMART THRESHOLD EXCEEDED (") {
              result = 'FAIL';
            }

            switch (result) {
              case "OK":
                data.passed = data.passed + 1;
                cumul.passed = cumul.passed + 1;
                cumul.total = cumul.total + 1;
                break;

              case "KO":
              case "FAIL":
              case "FAILED":
              case "FAILURE":
                data.failed = data.failed + 1;
                cumul.failed = cumul.failed + 1;
                cumul.total = cumul.total + 1;
                break;

              case null:
                // console.log("685 - <wiped>....");
                data.other = data.other + 1;
                cumul.other = cumul.other + 1;
                cumul.total = cumul.total + 1;
                break;

              default:
                data.other = data.other + 1;
                cumul.other = cumul.other + 1;
                cumul.total = cumul.total + 1;
            }
            data.total = data.passed + data.failed + data.other;
            mapDiskData.set(size_commercial, data);
          }
        })
      }
    }

    const sortedMap = [...mapDiskData].sort((a, b) => {
      const regex = /(?<Value>[+-]?([0-9]*[.])?[0-9]+)\s(?<Unit>\w*)/gm;  //
      if (!a[0] || !b[0]) {
        return 1;
      }

      const tmpA = a[0].split(regex);
      const tmpB = b[0].split(regex);

      if (!tmpA || !tmpB) {
        return 1;
      }

      if (tmpA.length !== 5 || tmpB.length !== 5) {
        return 1;
      }

      // const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let unitA = 1;
      switch (tmpA[3].toUpperCase()) {
        case 'YB':
          unitA = unitA * 1024;
        case 'ZB':
          unitA = unitA * 1024;
        case 'EB':
          unitA = unitA * 1024;
        case 'PB':
          unitA = unitA * 1024;
        case 'TB':
          unitA = unitA * 1024;
        case 'GB':
          unitA = unitA * 1024;
        case 'MB':
          unitA = unitA * 1024;
        case 'KB':
          unitA = unitA * 1024;
      }

      let unitB = 1;
      switch (tmpB[3].toUpperCase()) {
        case 'YB':
          unitB = unitB * 1024;
        case 'ZB':
          unitB = unitB * 1024;
        case 'EB':
          unitB = unitB * 1024;
        case 'PB':
          unitB = unitB * 1024;
        case 'TB':
          unitB = unitB * 1024;
        case 'GB':
          unitB = unitB * 1024;
        case 'MB':
          unitB = unitB * 1024;
        case 'KB':
          unitB = unitB * 1024;
      }

      const valueA = parseFloat(tmpA[1]) * unitA;
      const valueB = parseFloat(tmpB[1]) * unitB;

      if (valueA > valueB)
        return 1;
      else
        return -1;
    })
    const finalMapDiskData = new Map(sortedMap);

    let indiceId = 0;
    finalMapDiskData.forEach((value, key, map) => {

      const newRow = {
        id: indiceId,
        firstColumn: key,
        passed: value.passed,
        failed: value.failed,
        other: value.other,
        total: value.total
      }
      retRows.push(newRow);
      indiceId = indiceId + 1;
    });

    const newRow = {
      id: indiceId,
      firstColumn: 'TOTAL',
      passed: cumul.passed,
      failed: cumul.failed,
      other: cumul.other,
      total: cumul.total,
      cumulRow: true
    }
    retRows.push(newRow);
  }
  return retRows;
}


export const getWidgetDataForDiskErasurePerProtocol = (values) => {

  const retRows = [];

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {
    const cumul = {
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }
    const mapDiskData = new Map();

    for (const row of values.rows) {
      const arrayDisk = [];
      const dep = values.deployments[row.key];

      // console.log("384 - dep=", dep);
      const wipedList = dep.wiped_data && dep.wiped_data.split('<wiped>');

      if (wipedList) {
        wipedList.forEach(wipe => {
          const diskData = fixAndParse(wipe);
          arrayDisk.push(diskData);
        });

        arrayDisk.map((disk, index) => {
          let result = disk && disk.result;
          const algorithm = disk && disk.algorithm || "";

          if (algorithm !== "") {
            let data = mapDiskData.get(algorithm);

            if (!data) {
              data = {
                passed: 0,
                failed: 0,
                other: 0,
                total: 0
              }
            }

            if (result && result.toUpperCase().substring(0, 26) === "SMART THRESHOLD EXCEEDED (") {
              result = 'FAIL';
            }

            switch (result) {
              case "OK":
                data.passed = data.passed + 1;
                cumul.passed = cumul.passed + 1;
                cumul.total = cumul.total + 1;
                break;

              case "KO":
              case "FAIL":
              case "FAILED":
              case "FAILURE":
                data.failed = data.failed + 1;
                cumul.failed = cumul.failed + 1;
                cumul.total = cumul.total + 1;
                break;

              case null:
                // console.log("861 - <wiped>....");
                data.other = data.other + 1;
                cumul.other = cumul.other + 1;
                cumul.total = cumul.total + 1;
                break;

              default:
                data.other = data.other + 1;
                cumul.other = cumul.other + 1;
                cumul.total = cumul.total + 1;
            }
            data.total = data.passed + data.failed + data.other;
            mapDiskData.set(algorithm, data);
          }
        })
      }
    }

    const sortedMap = [...mapDiskData].sort((a, b) => {
      return a[0].toUpperCase().localeCompare(b[0].toUpperCase())
    })
    const finalMapDiskData = new Map(sortedMap);

    let indiceId = 0;
    finalMapDiskData.forEach((value, key, map) => {

      const newRow = {
        id: indiceId,
        firstColumn: key,
        passed: value.passed,
        failed: value.failed,
        other: value.other,
        total: value.total
      }
      retRows.push(newRow);
      indiceId = indiceId + 1;
    });

    const newRow = {
      id: indiceId,
      firstColumn: 'TOTAL',
      passed: cumul.passed,
      failed: cumul.failed,
      other: cumul.other,
      total: cumul.total,
      cumulRow: true
    }
    retRows.push(newRow);
  }
  return retRows;
}



export const getWidgetDataForDiskErasurePerBrand = (values) => {
  const retRows = [];

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {
    const cumul = {
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    const mapDiskData = new Map();

    for (const row of values.rows) {
      const arrayDisk = [];
      const dep = values.deployments[row.key];

      // console.log("384 - dep=", dep);
      const wipedList = dep.wiped_data && dep.wiped_data.split('<wiped>');

      if (wipedList) {
        wipedList.forEach(wipe => {
          const diskData = fixAndParse(wipe);
          arrayDisk.push(diskData);
        });

        arrayDisk.map((disk, index) => {
          let result = disk && disk.result;
          const manufacturer = disk && disk.manufacturer || "";

          if (manufacturer !== "") {
            let data = mapDiskData.get(manufacturer);

            if (!data) {
              data = {
                passed: 0,
                failed: 0,
                other: 0,
                total: 0
              }
            }

            if (result && result.toUpperCase().substring(0, 26) === "SMART THRESHOLD EXCEEDED (") {
              result = 'FAIL';
            }

            switch (result) {
              case "OK":
                data.passed = data.passed + 1;
                cumul.passed = cumul.passed + 1;
                cumul.total = cumul.total + 1;
                break;

              case "KO":
              case "FAIL":
              case "FAILED":
              case "FAILURE":
                data.failed = data.failed + 1;
                cumul.failed = cumul.failed + 1;
                cumul.total = cumul.total + 1;
                break;

              case null:
                // console.log("975 - <wiped>....");
                data.other = data.other + 1;
                cumul.other = cumul.other + 1;
                cumul.total = cumul.total + 1;
                break;

              default:
                data.other = data.other + 1;
                cumul.other = cumul.other + 1;
                cumul.total = cumul.total + 1;
            }
            data.total = data.passed + data.failed + data.other;
            mapDiskData.set(manufacturer, data);
          }
        })
      }
    }

    const sortedMap = [...mapDiskData].sort((a, b) => {
      return a[0].toUpperCase().localeCompare(b[0].toUpperCase())
    })

    const finalMapDiskData = new Map(sortedMap);

    let indiceId = 0;
    finalMapDiskData.forEach((value, key, map) => {

      const newRow = {
        id: indiceId,
        firstColumn: key,
        passed: value.passed,
        failed: value.failed,
        other: value.other,
        total: value.total
      }
      retRows.push(newRow);
      indiceId = indiceId + 1;
    });

    const newRow = {
      id: indiceId,
      firstColumn: 'TOTAL',
      passed: cumul.passed,
      failed: cumul.failed,
      other: cumul.other,
      total: cumul.total,
      cumulRow: true
    }
    retRows.push(newRow);
  }
  return retRows;
}



export const getWidgetDataForDiskErasurePerBrandAndModel = (values) => {
  const retRows = [];

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {
    const cumul = {
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }
    const mapDiskData = new Map();

    for (const row of values.rows) {
      const arrayDisk = [];
      const dep = values.deployments[row.key];

      // console.log("384 - dep=", dep);
      const wipedList = dep.wiped_data && dep.wiped_data.split('<wiped>');

      if (wipedList) {
        wipedList.forEach(wipe => {
          const diskData = fixAndParse(wipe);
          arrayDisk.push(diskData);
        });

        arrayDisk.map((disk, index) => {
          let result = disk && disk.result;
          const manufacturer = disk && disk.manufacturer || "";
          const model = disk && disk.model || "?";

          if (manufacturer !== "") {
            let data = mapDiskData.get(manufacturer + ' / ' + model);

            if (!data) {
              data = {
                passed: 0,
                failed: 0,
                other: 0,
                total: 0
              }
            }

            if (result && result.toUpperCase().substring(0, 26) === "SMART THRESHOLD EXCEEDED (") {
              result = 'FAIL';
            }

            switch (result) {
              case "OK":
                data.passed = data.passed + 1;
                cumul.passed = cumul.passed + 1;
                cumul.total = cumul.total + 1;
                break;

              case "KO":
              case "FAIL":
              case "FAILED":
              case "FAILURE":
                data.failed = data.failed + 1;
                cumul.failed = cumul.failed + 1;
                cumul.total = cumul.total + 1;
                break;

              case null:
                // console.log("1090 - <wiped>....");
                data.other = data.other + 1;
                cumul.other = cumul.other + 1;
                cumul.total = cumul.total + 1;
                break;

              default:
                data.other = data.other + 1;
                cumul.other = cumul.other + 1;
                cumul.total = cumul.total + 1;
            }
            data.total = data.passed + data.failed + data.other;
            mapDiskData.set(manufacturer + ' / ' + model, data);
          }
        })
      }
    }

    const sortedMap = [...mapDiskData].sort((a, b) => {
      return a[0].toUpperCase().localeCompare(b[0].toUpperCase())
    })

    const finalMapDiskData = new Map(sortedMap);

    let indiceId = 0;
    finalMapDiskData.forEach((value, key, map) => {

      const newRow = {
        id: indiceId,
        firstColumn: key,
        passed: value.passed,
        failed: value.failed,
        other: value.other,
        total: value.total
      }
      retRows.push(newRow);
      indiceId = indiceId + 1;
    });

    const newRow = {
      id: indiceId,
      firstColumn: 'TOTAL',
      passed: cumul.passed,
      failed: cumul.failed,
      other: cumul.other,
      total: cumul.total,
      cumulRow: true
    }
    retRows.push(newRow);
  }
  return retRows;
}



export const getWidgetDataForDiagnostics = (values) => {
  const retRows = [];

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {

    // ALL DEVICES --------------------------------------
    const newAllDevicesRow = {
      id: 0,
      firstColumn: values.t('reporting.columns.statistics.all_devices'),//"All devices",
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    for (const row of values.rows) {
      const dep = values.deployments[row.key];

      switch (dep.module_1136_result) {
        case "OK":
          newAllDevicesRow.passed = newAllDevicesRow.passed + 1;
          break;

        case "KO":
        case "FAIL":
        case "FAILED":
        case "FAILURE":
          newAllDevicesRow.failed = newAllDevicesRow.failed + 1;
          break;

        case null:
          // console.log("1173 - module_1136_result....");
          newAllDevicesRow.other = newAllDevicesRow.other + 1;
          break;

        default:
          newAllDevicesRow.other = newAllDevicesRow.other + 1;
      }
    }
    newAllDevicesRow.total = newAllDevicesRow.passed + newAllDevicesRow.failed + newAllDevicesRow.other;
    retRows.push(newAllDevicesRow);
    // ALL DEVICES --------------------------------------


    // ALL UNIQUE DEVICES -------------------------------
    const newAllUniqueDevicesRow = {
      id: 1,
      firstColumn: values.t('reporting.columns.statistics.all_unique_devices'),
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    const filteredDeployments = [];
    for (const row of values.rows) {
      const dep = values.deployments[row.key];
      filteredDeployments.push(dep);
    }

    const orderedDeployments = filteredDeployments.sort((a, b) => {
      return a.date < b.date ? 1 : -1;
    });

    const uniqueDeployments = [];
    for (const dep of orderedDeployments) {
      // console.log("1251 - dep=", dep);
      const found = uniqueDeployments.find(d => {
        // if (d.system_serial === dep.system_serial) {
        if (
          d && dep &&
          (
            (values.scenario && values.scenario.devicesType === devicesTypeValues.PCs && d.system_serial === dep.system_serial)
            ||
            (values.scenario && values.scenario.devicesType === devicesTypeValues.disks && d.serial === dep.serial)
          )
        ) {

          const cpuListDep = dep.cpu_data && dep.cpu_data.split('<cpu>');
          let cpuModelDep = "";
          if (cpuListDep) {
            cpuListDep.forEach(cpu => {
              const cpuData = fixAndParse(cpu);
              if (cpuData.model !== "") {
                if (cpuModelDep !== "")
                  cpuModelDep = cpuModelDep + line_separator;
                cpuModelDep += cpuData.model;
              }
            });
          }

          const cpuListD = d.cpu_data && d.cpu_data.split('<cpu>');
          let cpuModelD = "";
          if (cpuListD) {
            cpuListD.forEach(cpu => {
              const cpuData = fixAndParse(cpu);
              if (cpuData.model !== "") {
                if (cpuModelD !== "")
                  cpuModelD = cpuModelD + line_separator;
                cpuModelD += cpuData.model;
              }
            });
          }

          if (
            d.system_uuid === dep.system_uuid &&
            d.motherboard_model === dep.motherboard_model &&
            cpuModelD === cpuModelDep
          ) {
            return true;
          }
        }
        return false;
      });
      // d.system_serial === dep.system_serial);
      if (!found) {
        uniqueDeployments.push(dep);
      }
    }

    for (const dep of uniqueDeployments) {
      switch (dep.module_1136_result) {
        case "OK":
          newAllUniqueDevicesRow.passed = newAllUniqueDevicesRow.passed + 1;
          break;

        case "KO":
        case "FAIL":
        case "FAILED":
        case "FAILURE":
          newAllUniqueDevicesRow.failed = newAllUniqueDevicesRow.failed + 1;
          break;

        case null:
          newAllUniqueDevicesRow.other = newAllUniqueDevicesRow.other + 1;
          break;

        default:
          newAllUniqueDevicesRow.other = newAllUniqueDevicesRow.other + 1;
      }
    }
    newAllUniqueDevicesRow.total = newAllUniqueDevicesRow.passed + newAllUniqueDevicesRow.failed + newAllUniqueDevicesRow.other;
    retRows.push(newAllUniqueDevicesRow);
    // ALL UNIQUE DEVICES -------------------------------

  }
  return retRows;
}




export const getWidgetDataForDiagnosticsPerTest = (values) => {
  const retRows = [];

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {
    const cumul = {
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }
    const mapTestData = new Map();

    for (const row of values.rows) {
      const arrayTest = [];
      const dep = values.deployments[row.key];
      const testList = dep.tests_data && dep.tests_data.split('<tests>');

      // console.log("993 - dep=", dep);
      // console.log("994 - dep.tests_data=", dep.tests_data);

      if (testList) {
        testList.forEach(test => {
          const testData = fixAndParse(test);
          arrayTest.push(testData);
        });

        // console.log("999 - dep=", dep);
        // console.log("1003 - arrayTest=", arrayTest);
        arrayTest.map((test, index) => {
          let result = test && test.test_result;

          const found = diag_code_ids.find(element => {
            return element.id === test.test_id
          });
          // console.log("1010 - found=", found);

          // const catName = values.t(`reporting.columns.${found.category}.sub_title`);
          // let testName = values.t(`reporting.columns.${found.category}.${found.test}`);

          // console.log("1015 - catName=", catName);
          // console.log("1016 - testName=", testName);

          let testName = values.t(`reporting.columns.unknow_test`);
          if (found)
            testName = values.t(`reporting.columns.${found.category}.sub_title`) + ' (' + values.t(`reporting.columns.${found.category}.${found.test}`) + ')';
         
          if (testName !== "") {
            let data = mapTestData.get(testName);

            if (!data) {
              data = {
                passed: 0,
                failed: 0,
                other: 0,
                total: 0
              }
            }

            switch (result) {
              case 0:
              case "0":
                data.passed = data.passed + 1;
                cumul.passed = cumul.passed + 1;
                cumul.total = cumul.total + 1;
                break;

              case 1:
              case "1":
                data.failed = data.failed + 1;
                cumul.failed = cumul.failed + 1;
                cumul.total = cumul.total + 1;
                break;

              case null:
                // console.log("1173 - <tests>....");
                data.other = data.other + 1;
                cumul.other = cumul.other + 1;
                cumul.total = cumul.total + 1;
                break;

              default:
                data.other = data.other + 1;
                cumul.other = cumul.other + 1;
                cumul.total = cumul.total + 1;
            }
            data.total = data.passed + data.failed + data.other;
            mapTestData.set(testName, data);
          }
        })
      }
    }

    const sortedMap = [...mapTestData].sort((a, b) => {
      return a[0].toUpperCase().localeCompare(b[0].toUpperCase())
    })

    const finalMapTestData = new Map(sortedMap);

    let indiceId = 0;
    finalMapTestData.forEach((value, key, map) => {

      const newRow = {
        id: indiceId,
        firstColumn: key,
        passed: value.passed,
        failed: value.failed,
        other: value.other,
        total: value.total
      }
      retRows.push(newRow);
      indiceId = indiceId + 1;
    });

    const newRow = {
      id: indiceId,
      firstColumn: 'TOTAL',
      passed: cumul.passed,
      failed: cumul.failed,
      other: cumul.other,
      total: cumul.total,
      cumulRow: true
    }
    retRows.push(newRow);
  }
  return retRows;
}


//======================================================================================

export const getWidgetDataForDisksErasurePerCapacity = (values) => {

  // console.log("1100 - values=", values);
  const retRows = [];
  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {
    const cumul = {
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    const mapDiskData = new Map();

    for (const row of values.rows) {
      const dep = values.deployments[row.key];

      // console.log("391 - disk=", disk);
      let result = dep && dep.result;
      const size_commercial = dep && dep.size_commercial || "";

      if (size_commercial) {
        let data = mapDiskData.get(size_commercial);

        if (!data) {
          data = {
            passed: 0,
            failed: 0,
            other: 0,
            total: 0
          }
        }

        if (result && result.toUpperCase().substring(0, 26) === "SMART THRESHOLD EXCEEDED (") {
          result = 'FAIL';
        }

        switch (result) {
          case "OK":
            data.passed = data.passed + 1;
            cumul.passed = cumul.passed + 1;
            cumul.total = cumul.total + 1;
            break;

          case "KO":
          case "FAIL":
          case "FAILED":
          case "FAILURE":
            data.failed = data.failed + 1;
            cumul.failed = cumul.failed + 1;
            cumul.total = cumul.total + 1;
            break;

          case null:
            // console.log("1425 - <disk>....");
            data.other = data.other + 1;
            cumul.other = cumul.other + 1;
            cumul.total = cumul.total + 1;
            break;

          default:
            data.other = data.other + 1;
            cumul.other = cumul.other + 1;
            cumul.total = cumul.total + 1;
        }
        data.total = data.passed + data.failed + data.other;
        mapDiskData.set(size_commercial, data);
      }
    }

    const sortedMap = [...mapDiskData].sort((a, b) => {
      const regex = /(?<Value>[+-]?([0-9]*[.])?[0-9]+)\s(?<Unit>\w*)/gm;  //
      if (!a[0] || !b[0]) {
        return 1;
      }

      const tmpA = a[0].split(regex);
      const tmpB = b[0].split(regex);

      if (!tmpA || !tmpB) {
        return 1;
      }

      if (tmpA.length !== 5 || tmpB.length !== 5) {
        return 1;
      }

      // const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let unitA = 1;
      switch (tmpA[3].toUpperCase()) {
        case 'YB':
          unitA = unitA * 1024;
        case 'ZB':
          unitA = unitA * 1024;
        case 'EB':
          unitA = unitA * 1024;
        case 'PB':
          unitA = unitA * 1024;
        case 'TB':
          unitA = unitA * 1024;
        case 'GB':
          unitA = unitA * 1024;
        case 'MB':
          unitA = unitA * 1024;
        case 'KB':
          unitA = unitA * 1024;
      }

      let unitB = 1;
      switch (tmpB[3].toUpperCase()) {
        case 'YB':
          unitB = unitB * 1024;
        case 'ZB':
          unitB = unitB * 1024;
        case 'EB':
          unitB = unitB * 1024;
        case 'PB':
          unitB = unitB * 1024;
        case 'TB':
          unitB = unitB * 1024;
        case 'GB':
          unitB = unitB * 1024;
        case 'MB':
          unitB = unitB * 1024;
        case 'KB':
          unitB = unitB * 1024;
      }

      const valueA = parseFloat(tmpA[1]) * unitA;
      const valueB = parseFloat(tmpB[1]) * unitB;

      if (valueA > valueB)
        return 1;
      else
        return -1;
    })
    const finalMapDiskData = new Map(sortedMap);

    let indiceId = 0;
    finalMapDiskData.forEach((value, key, map) => {

      const newRow = {
        id: indiceId,
        firstColumn: key,
        passed: value.passed,
        failed: value.failed,
        other: value.other,
        total: value.total
      }
      retRows.push(newRow);
      indiceId = indiceId + 1;
    });

    const newRow = {
      id: indiceId,
      firstColumn: 'TOTAL',
      passed: cumul.passed,
      failed: cumul.failed,
      other: cumul.other,
      total: cumul.total,
      cumulRow: true
    }
    retRows.push(newRow);
  }
  return retRows;
}


export const getWidgetDataForDisksErasurePerProtocol = (values) => {

  const retRows = [];

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {
    const cumul = {
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }
    const mapDiskData = new Map();

    for (const row of values.rows) {
      const dep = values.deployments[row.key];

      let result = dep && dep.result;
      const algorithm = dep && dep.algorithm || "";

      if (algorithm !== "") {
        let data = mapDiskData.get(algorithm);

        if (!data) {
          data = {
            passed: 0,
            failed: 0,
            other: 0,
            total: 0
          }
        }

        if (result && result.toUpperCase().substring(0, 26) === "SMART THRESHOLD EXCEEDED (") {
          result = 'FAIL';
        }

        switch (result) {
          case "OK":
            data.passed = data.passed + 1;
            cumul.passed = cumul.passed + 1;
            cumul.total = cumul.total + 1;
            break;

          case "KO":
          case "FAIL":
          case "FAILED":
          case "FAILURE":
            data.failed = data.failed + 1;
            cumul.failed = cumul.failed + 1;
            cumul.total = cumul.total + 1;
            break;

          case null:
            // console.log("1588 - <disk>....");
            data.other = data.other + 1;
            cumul.other = cumul.other + 1;
            cumul.total = cumul.total + 1;
            break;

          default:
            data.other = data.other + 1;
            cumul.other = cumul.other + 1;
            cumul.total = cumul.total + 1;
        }
        data.total = data.passed + data.failed + data.other;
        mapDiskData.set(algorithm, data);

      }
    }

    const sortedMap = [...mapDiskData].sort((a, b) => {
      return a[0].toUpperCase().localeCompare(b[0].toUpperCase())
    })
    const finalMapDiskData = new Map(sortedMap);

    let indiceId = 0;
    finalMapDiskData.forEach((value, key, map) => {

      const newRow = {
        id: indiceId,
        firstColumn: key,
        passed: value.passed,
        failed: value.failed,
        other: value.other,
        total: value.total
      }
      retRows.push(newRow);
      indiceId = indiceId + 1;
    });

    const newRow = {
      id: indiceId,
      firstColumn: 'TOTAL',
      passed: cumul.passed,
      failed: cumul.failed,
      other: cumul.other,
      total: cumul.total,
      cumulRow: true
    }
    retRows.push(newRow);
  }
  return retRows;
}



export const getWidgetDataForDisksErasurePerBrand = (values) => {
  const retRows = [];

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {
    const cumul = {
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }

    const mapDiskData = new Map();

    for (const row of values.rows) {
      const dep = values.deployments[row.key];

      let result = dep && dep.result;
      const manufacturer = dep && dep.manufacturer || "";

      if (manufacturer !== "") {
        let data = mapDiskData.get(manufacturer);

        if (!data) {
          data = {
            passed: 0,
            failed: 0,
            other: 0,
            total: 0
          }
        }

        if (result && result.toUpperCase().substring(0, 26) === "SMART THRESHOLD EXCEEDED (") {
          result = 'FAIL';
        }

        switch (result) {
          case "OK":
            data.passed = data.passed + 1;
            cumul.passed = cumul.passed + 1;
            cumul.total = cumul.total + 1;
            break;

          case "KO":
          case "FAIL":
          case "FAILED":
          case "FAILURE":
            data.failed = data.failed + 1;
            cumul.failed = cumul.failed + 1;
            cumul.total = cumul.total + 1;
            break;

          case null:
            // console.log("1690 - <disks>....");
            data.other = data.other + 1;
            cumul.other = cumul.other + 1;
            cumul.total = cumul.total + 1;
            break;

          default:
            data.other = data.other + 1;
            cumul.other = cumul.other + 1;
            cumul.total = cumul.total + 1;
        }
        data.total = data.passed + data.failed + data.other;
        mapDiskData.set(manufacturer, data);

      }
    }

    const sortedMap = [...mapDiskData].sort((a, b) => {
      return a[0].toUpperCase().localeCompare(b[0].toUpperCase())
    })

    const finalMapDiskData = new Map(sortedMap);

    let indiceId = 0;
    finalMapDiskData.forEach((value, key, map) => {

      const newRow = {
        id: indiceId,
        firstColumn: key,
        passed: value.passed,
        failed: value.failed,
        other: value.other,
        total: value.total
      }
      retRows.push(newRow);
      indiceId = indiceId + 1;
    });

    const newRow = {
      id: indiceId,
      firstColumn: 'TOTAL',
      passed: cumul.passed,
      failed: cumul.failed,
      other: cumul.other,
      total: cumul.total,
      cumulRow: true
    }
    retRows.push(newRow);
  }
  return retRows;
}



export const getWidgetDataForDisksErasurePerBrandAndModel = (values) => {
  const retRows = [];

  if (values.rows && values.rows.length > 0 && values.deployments && values.deployments.length > 0) {
    const cumul = {
      passed: 0,
      failed: 0,
      other: 0,
      total: 0
    }
    const mapDiskData = new Map();

    for (const row of values.rows) {
      const dep = values.deployments[row.key];

      let result = dep && dep.result;
      const manufacturer = dep && dep.manufacturer || "";
      const model = dep && dep.model || "?";

      if (manufacturer !== "") {
        let data = mapDiskData.get(manufacturer + ' / ' + model);

        if (!data) {
          data = {
            passed: 0,
            failed: 0,
            other: 0,
            total: 0
          }
        }

        if (result && result.toUpperCase().substring(0, 26) === "SMART THRESHOLD EXCEEDED (") {
          result = 'FAIL';
        }

        switch (result) {
          case "OK":
            data.passed = data.passed + 1;
            cumul.passed = cumul.passed + 1;
            cumul.total = cumul.total + 1;
            break;

          case "KO":
          case "FAIL":
          case "FAILED":
          case "FAILURE":
            data.failed = data.failed + 1;
            cumul.failed = cumul.failed + 1;
            cumul.total = cumul.total + 1;
            break;

          case null:
            // console.log("1793 - <disks>....");
            data.other = data.other + 1;
            cumul.other = cumul.other + 1;
            cumul.total = cumul.total + 1;
            break;

          default:
            data.other = data.other + 1;
            cumul.other = cumul.other + 1;
            cumul.total = cumul.total + 1;
        }
        data.total = data.passed + data.failed + data.other;
        mapDiskData.set(manufacturer + ' / ' + model, data);
      }
    }

    const sortedMap = [...mapDiskData].sort((a, b) => {
      return a[0].toUpperCase().localeCompare(b[0].toUpperCase())
    })

    const finalMapDiskData = new Map(sortedMap);

    let indiceId = 0;
    finalMapDiskData.forEach((value, key, map) => {

      const newRow = {
        id: indiceId,
        firstColumn: key,
        passed: value.passed,
        failed: value.failed,
        other: value.other,
        total: value.total
      }
      retRows.push(newRow);
      indiceId = indiceId + 1;
    });

    const newRow = {
      id: indiceId,
      firstColumn: 'TOTAL',
      passed: cumul.passed,
      failed: cumul.failed,
      other: cumul.other,
      total: cumul.total,
      cumulRow: true
    }
    retRows.push(newRow);
  }
  return retRows;
}